<template>
  <div class="guidance">
    <!-- 保持banner部分不变 -->
    <div class="banner">
      <div class="contentMain">
        <div class="title"> AI驱动 智灵未来 </div>
        <div class="title"> &nbsp;&nbsp;&nbsp;解决方案服务商 </div>
        <div class="titleTip"> </div>
      </div>
      <el-image :src="logo"></el-image>
      <!-- 中心水波纹 -->
      <div class="ripple-effect center-ripple"></div>
      <!-- 左侧水波纹 -->
      <div class="ripple-effect left-ripple"></div>
    </div>

    <!-- 优化itemMain部分 -->
    <div class="itemMain-container">
      <div class="itemMain">
        <h1 class="h1-title">行业资讯</h1>

        <!-- 使用v-for简化重复代码 -->
        <div class="news-box" v-for="(item, index) in newsList" :key="index">
          <div class="news-item">
            <el-image :src="item.img" class="news-img"></el-image>
            <div class="news-content" @click="showDialog(item)">
              <h2>{{ item.title }}</h2>
              <p class="provenance-text">
                <span>{{ item.author }}</span>
                <span>{{ item.date }}</span>
              </p>
              <p class="news-content-text">{{ item.content }}</p>
            </div>
          </div>
        </div>

        <div class="pagesite" align="center">
          <el-pagination layout="prev, pager, next" :total="100" :page-size="10" :current-page="currentPage"
            @current-change="handlePageChange">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加对话框 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" :title="currentItem.title">
      <div class="dialog-content" style="text-align: center;">
        <p style="color: red;">(行业资讯为付费内容，0.5元/条)</p>
        <img src="./images/pay.jpg" style="width: 50%; margin-bottom: 20px;">
        <p>{{ currentItem.content }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { Pagination } from 'element-ui'
export default {
  name: "Guidance",
  components: {
    'el-pagination': Pagination
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      logo: require("./images/banner1.png"),
      dialogVisible: false,  // 添加对话框显示状态
      currentItem: {},       // 添加当前选中项
      newsList: [
        {
          img: require("./images/8.jpg"),
          title: "私域流量变现深度运营方案",
          author: "本站编辑",
          date: "2025年07月26日",
          content: "针对企业微信+社群+小程序的私域闭环，提供从引流到转化的全链路设计。例如，某美妆品牌通过‘企业微信个人号-社群分层-小程序会员体系’三步走策略，3个月内将复购率从15%提升至42%。具体包括：①设计诱饵产品（如9.9元小样）吸引用户添加企微；②根据消费频次划分社群（新客群/活跃群/沉睡群），推送差异化内容；③在小程序设置积分商城，消费1元=1积分，1000分兑换正装产品。关键点在于避免群内硬广，转而提供美妆技巧、限量秒杀等价值内容。..."
        },
        {
          img: require("./images/5.jpg"),
          title: "微信广告投放精准优化策略",
          author: "本站编辑",
          date: "2025年07月25日",
          content: "基于2025年微信广告新规则，详解如何通过AB测试降低获客成本。以某教育类小程序为例，通过三步优化将CPA从80元降至35元：①人群分层测试，发现25-35岁女性对’0元试听课‘广告点击率高出2.3倍；②素材迭代，将静态海报改为‘教师真人视频+成绩提升数据’动态素材，转化率提升27%；③落地页优化，在试听报名页添加‘已XX人领取’实时计数器，减少用户跳出。重点规避医疗、金融等敏感行业的关键词触发风控。..."
        },
        {
          img: require("./images/2.jpg"),
          title: "搜一搜SEO全维度优化指南",
          author: "本站编辑",
          date: "2025年07月24日",
          content: "深度解析微信搜一搜的算法权重（2025年最新版），包含标题关键词布局、服务类目选择、用户评价维护等7大维度。某本地家政小程序通过优化：①名称加入'深圳''保洁'等地域+行业词；②在简介中埋入'开荒清洁''''家电清洗'等长尾词；③激励用户在小程序内发布带关键词的评价（如'油烟机清洗得很干净'），6个月后搜索流量增长300%。特别提醒避免堆砌关键词，需结合真实服务场景设计自然语句。..."
        },
        {
          img: require("./images/4.jpg"),
          title: "视频号直播+小程序深度耦合方案",
          author: "本站编辑",
          date: "2025年07月21日",
          content: "针对视频号直播带货场景，提供从流量获取到小程序转化的全流程设计。以某食品品牌为例，通过以下策略实现单场直播GMV破百万：①预热阶段在私域社群发布'直播剧透短视频'，点击直接跳转小程序预约页面，积累初始流量池；②直播中设置'小程序专享价'（比直播间价格低5%），引导用户跳转下单；③利用小程序'拼团功能'实现观看用户自发裂变，单人成团可享额外折扣。关键点在于直播话术设计——每15分钟强调一次'点击下方小程序卡片领取专属福利'，强化用户行为路径。..."
        },
        {
          img: require("./images/1.jpg"),
          title: "社交裂变活动合规化设计",
          author: "本站编辑",
          date: "2025年07月10日",
          content: "针对微信生态的裂变风控规则，提供2025年最新合规玩法。某知识付费小程序通过'阶梯式任务奖励'实现7日新增用户5万+：①一级任务（低门槛）：分享海报到朋友圈可得免费试听章节，利用'虚荣心理'设计带有用户昵称+头像的个性化海报；②二级任务（中门槛）：邀请3位好友注册解锁全部课程目录，设置实时进度条刺激完成欲；③三级任务（高门槛）：邀请10人加入学习社群获得实体周边，采用'团队PK'模式增强趣味性。特别注意规避'强制转发''''虚假奖励'等微信明令禁止的玩法。..."
        },
        {
          img: require("./images/12.jpg"),
          title: "线下场景LBS智能推送系统",
          author: "本站编辑",
          date: "2025年07月09日",
          content: "针对实体门店的线上线下联动需求，开发基于地理位置的场景化营销方案。某连锁超市小程序通过'三步精准触达'使到店转化率提升28%：①在门店3公里范围内投放微信朋友圈广告，推送'扫码领30元新人券'（需开启位置权限）；②用户进入小程序后自动弹出'附近门店热销榜'，根据过往购买记录推荐商品；③离店后推送'遗忘商品提醒'（如用户浏览过但未购买的牛奶特价信息）。关键技术点在于蓝牙信标（iBeacon）的部署，实现1米级精度的到店识别。..."
        },
        {
          img: require("./images/14.jpg"),
          title: "小程序矩阵化运营架构设计",
          author: "本站编辑",
          date: "2025年07月09日",
          content: "针对多业务线企业，规划主小程序+垂直子小程序的矩阵体系。某汽车品牌通过'1+3'矩阵（主商城+试驾预约+车主社区+售后服务）实现用户LTV提升40%：①主商城作为流量枢纽，所有子小程序在首页设有交叉入口；②试驾小程序侧重表单转化，采用极简设计（仅需填写手机号+选择车型）；③社区小程序通过'车主认证'机制筛选高质量UGC内容；④服务小程序集成预约保养、道路救援等高频功能。数据打通是关键——所有小程序共用同一套用户ID体系。... "
        },
        {
          img: require("./images/13.jpg"),
          title: "抖音跨平台引流技术方案",
          author: "本站编辑",
          date: "2025年07月09日",
          content: "详解如何突破平台壁垒，将抖音流量导入微信小程序。某服装品牌通过'短视频+企业号+小程序'组合拳实现日均3000+跳转：①在抖音视频评论区置顶'点击主页链接'引导语；②企业号主页设置'企业微信添加'按钮，沉淀用户至私域；③通过抖音星图任务招募达人，发布带小程序口令码的穿搭视频（口令码可规避直接外链限制）。核心在于内容设计——抖音侧重'场景化展示'（如办公室穿搭切换），而跳转小程序后立即推送'同款套装限时拼团'。... "
        }, {
          img: require("./images/11.jpg"),
          title: "AI驱动的小程序用户运营系统",
          author: "本站编辑",
          date: "2025年07月09日",
          content: "接入机器学习模型实现精准运营。某阅读类小程序通过AI系统使30日留存率翻倍：①用户分群模型：根据阅读时长、品类偏好等20+维度自动划分8类人群；②个性化推送：给'悬疑小说爱好者'在每周五晚8点（其活跃高峰）推送'新书限免'消息；③流失预警：对连续3天未打开的用户自动发放'补签卡'福利。系统需对接微信云开发数据库，实时更新用户行为标签。... "
        }, {
          img: require("./images/15.jpg"),
          title: "垂直行业定制化解决方案",
          author: "本站编辑",
          date: "2025年07月09日",
          content: "提供教育/医疗/政务等特殊行业的合规解决方案。某互联网医院小程序通过以下设计实现日均问诊量2000+：①预问诊AI机器人（降低医生初筛工作量）；②处方笺加密传输至合作药房小程序；③医保支付接口对接（需申请微信医疗类目特殊资质）。特别注意医疗内容审核机制——所有科普文章需先通过NLP模型检测是否存在违规术语。... "
        },
        // 其他新闻项...
      ]
    };
  }, methods: {
    showDialog(item) {
      //item.img = require("./images/pay.jpg");
      this.currentItem = item;
      this.dialogVisible = true;
    },
    handlePageChange(val) {
      this.currentPage = val;
       this.loadPageData(val);
      // 这里可以添加加载对应页码数据的逻辑
      console.log(`切换到第 ${val} 页`);
    },
    loadPageData(page) {
      // 实际项目中这里应该是API请求
      console.log('加载第', page, '页数据');
    }
  }
};
</script>

<style scoped lang="less">
.guidance {
  margin-top: 100px;

  .banner {
    width: 100%;
    height: 30px;
    display: contents;
    position: relative;

    .el-image {
      display: contents;
    }

    .contentMain {
      position: absolute;
      top: 260px;
      left: 130px;
      z-index: 100;
      color: #ffffff;

      .title {
        font-size: 100px;
      }

      .titleTip {
        font-size: 50px;
        margin-top: 30px;
      }
    }
  }

  .itemMain-container {
    display: flex;
    justify-content: center;
    width: 100%;

    .itemMain {
      width: 80%;
      background: #fff;
      padding: 20px 0;

      .h1-title {
        margin: 15px;
        font-size: 45px;
        height: 50px;
        border-bottom: 1px solid #d7d7d7;
        padding-bottom: 4px;
        color: #000;
        font-weight: bold;
      }

      .news-box {
        margin: 25px 0;
        padding: 15px 0;
        border-bottom: 1px dashed #d5d5d5;

        .news-item {
          display: flex;
          gap: 20px;

          .news-img {
            width: 143px;
            height: 98px;
            object-fit: cover;
          }

          .news-content {
            flex: 1;

            h2 {
              font-size: 16px;
              color: #000;
              font-weight: bold;
              margin: 0 0 10px 0;
            }

            .provenance-text {
              font-size: 14px;
              color: #666;
              margin: 8px 0;

              span {
                padding-right: 15px;
              }
            }

            .news-content-text {
              font-size: 14px;
              color: #333;
              margin: 8px 0 0 0;
            }
          }
        }
      }
    }
  }

  /* 对话框内容样式 */
  .dialog-content {
    p {
      font-size: 16px;
      line-height: 1.6;
      color: #333;
    }
  }

  .dialog-footer {
    /* 自定义样式 */
    text-align: center;
    padding: 10px 0;
  }

  /* 水波纹基础样式 */
  .ripple-effect {
    position: absolute;
    width: 300px;
    height: 300px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    pointer-events: none;
    z-index: 5;
    transform: scale(0);
    animation: ripple 3s linear infinite;
    opacity: 0;
  }

  /* 中心水波纹 */
  .center-ripple {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
  }

  /* 左侧水波纹 */
  .left-ripple {
    top: 50%;
    left: 10%;
    /* 调整这个值可以改变左侧位置 */
    transform: translate(0, -50%) scale(0);
    animation-delay: 0.5s;
    /* 延迟启动，与中心波纹错开 */
  }

  @keyframes ripple {
    0% {
      transform: translate(-50%, -50%) scale(0);
      opacity: 0.5;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
  }

  /* 为左侧波纹单独设置动画 */
  .left-ripple::before {
    animation: ripple 3s linear infinite 1s;
  }


  /* 分页样式 */
  .pagesite {
    margin: 20px 0;
  }

  /* 自定义分页按钮样式 */
  .el-pagination {
    padding: 10px 0;
  }

  .el-pagination button,
  .el-pagination li:not(.disabled) {
    border-radius: 4px;
    margin: 0 5px;
  }

  .el-pagination .btn-next,
  .el-pagination .btn-prev {
    padding: 0 15px;
  }
}
</style>